/* SSL landing — Agentcy for SickScience */
(() => {
  const formatMoney = (cents, format = '${{amount}}') => {
    const value = Number(cents) / 100;
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = match ? match[1] : 'amount';
    const group = (num, decimals, thousands = ',', decimal = '.') => {
      const [int, frac] = num.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    let out;
    switch (key) {
      case 'amount_no_decimals': out = group(value, 0); break;
      case 'amount_with_comma_separator': out = group(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(value, 0, '.', ','); break;
      default: out = group(value, 2);
    }
    out = out.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  };

  class SslBeforeAfter extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('.ssl-ba__range');
      if (!range) return;
      const sync = () => this.style.setProperty('--ssl-pos', `${range.value}%`);
      range.addEventListener('input', sync);
      sync();
    }
  }

  class SslBuyBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[action*="/cart/add"]');
      if (!this.form) return;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.defaultPlan = (this.dataset.defaultPlan || '').trim().toLowerCase();
      this.idInput = this.form.querySelector('input[name="id"]');
      this.planInput = this.form.querySelector('input[name="selling_plan"]');
      this.offerInputs = [...this.querySelectorAll('[data-offer-input]')];
      this.purchase = this.querySelector('[data-purchase]');
      this.purchaseInputs = [...this.querySelectorAll('[data-purchase-input]')];
      this.planSelect = this.querySelector('[data-plan-select]');
      this.plans = [];

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-offer-input]')) this.onOfferChange();
        else if (event.target.matches('[data-purchase-input], [data-plan-select]')) this.update();
      });

      this.onOfferChange();
    }

    get offer() {
      return this.offerInputs.find((input) => input.checked) || this.offerInputs[0];
    }

    money(cents) {
      return formatMoney(cents, this.moneyFormat);
    }

    setText(selector, text) {
      this.querySelectorAll(selector).forEach((el) => { el.textContent = text; });
    }

    onOfferChange() {
      const offer = this.offer;
      if (!offer) return;
      let plans = [];
      try { plans = JSON.parse(offer.dataset.plans || '[]'); } catch (e) { plans = []; }
      this.plans = plans;

      if (this.planSelect) {
        const previous = this.planSelect.selectedOptions[0]?.textContent;
        this.planSelect.innerHTML = '';
        plans.forEach((plan) => this.planSelect.add(new Option(plan.name, plan.id)));
        const weeks = (name) => ((name || '').match(/\d+/) || [])[0];
        const wanted = weeks(this.defaultPlan);
        const target =
          plans.find((p) => p.name === previous) ||
          plans.find((p) => p.name.toLowerCase() === this.defaultPlan) ||
          (wanted && plans.find((p) => weeks(p.name) === wanted)) ||
          plans[0];
        if (target) this.planSelect.value = String(target.id);
      }

      if (this.purchase) this.purchase.hidden = plans.length === 0;
      this.update();
    }

    update() {
      const offer = this.offer;
      if (!offer) return;
      const price = Number(offer.dataset.price);
      const compare = Number(offer.dataset.compare) || 0;

      this.idInput.value = offer.dataset.variantId;

      const purchaseValue = this.purchaseInputs.find((input) => input.checked)?.value;
      const subscribe = this.plans.length > 0 && purchaseValue === 'subscribe';
      const selectedPlan =
        this.plans.find((p) => String(p.id) === this.planSelect?.value) || this.plans[0];
      const activePlan = subscribe ? selectedPlan : null;

      if (this.planInput) {
        this.planInput.disabled = !activePlan;
        this.planInput.value = activePlan ? activePlan.id : '';
      }

      if (selectedPlan) {
        const pct = Math.round(((price - selectedPlan.price) / price) * 100);
        this.setText('[data-sub-pct]', pct);
        this.setText('[data-sub-price]', this.money(selectedPlan.price));
        this.setText('[data-sub-compare]', this.money(price));
      }
      this.setText('[data-onetime-price]', this.money(price));

      this.querySelectorAll('[data-plan]').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.plan === (subscribe ? 'subscribe' : 'onetime'));
      });

      const finalPrice = activePlan ? activePlan.price : price;
      const strike = activePlan ? price : compare > price ? compare : 0;
      this.setText('[data-atc-price]', this.money(finalPrice));
      const atcCompare = this.querySelector('[data-atc-compare]');
      if (atcCompare) {
        atcCompare.textContent = strike ? this.money(strike) : '';
        atcCompare.hidden = !strike;
      }
    }
  }


  class SslQuiz extends HTMLElement {
    connectedCallback() {
      this.step1 = this.querySelector('[data-quiz-step="1"]');
      this.step2 = this.querySelector('[data-quiz-step="2"]');
      this.result = this.querySelector('[data-quiz-result]');
      this.progress = this.querySelector('[data-quiz-progress]');
      this.answer = null;

      this.step1?.addEventListener('change', (event) => {
        const input = event.target.closest('input[type="radio"]');
        if (!input) return;
        this.answer = input.value;
        if (input.dataset.hasSet === 'true') this.show('step2');
        else this.showResult('single');
      });
      this.step2?.addEventListener('change', (event) => {
        const input = event.target.closest('input[type="radio"]');
        if (input) this.showResult(input.value);
      });
      this.querySelector('[data-quiz-back]')?.addEventListener('click', () => this.show('step1'));
      this.querySelector('[data-quiz-restart]')?.addEventListener('click', () => {
        this.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = false; });
        this.show('step1');
      });
    }

    show(name) {
      const map = { step1: this.step1, step2: this.step2, result: this.result };
      Object.entries(map).forEach(([key, el]) => { if (el) el.hidden = key !== name; });
      if (this.progress) {
        this.progress.hidden = name === 'result';
        this.progress.textContent = name === 'step2' ? 'Question 2 of 2' : 'Question 1 of 2';
      }
      const focusTarget = name === 'result' ? this.result : map[name]?.querySelector('input');
      focusTarget?.focus({ preventScroll: true });
    }

    showResult(kind) {
      this.result.querySelectorAll('[data-result]').forEach((el) => {
        el.hidden = el.dataset.result !== `${this.answer}-${kind}`;
      });
      this.show('result');
    }
  }

  if (!customElements.get('ssl-quiz')) customElements.define('ssl-quiz', SslQuiz);
  if (!customElements.get('ssl-before-after')) customElements.define('ssl-before-after', SslBeforeAfter);
  if (!customElements.get('ssl-buy-box')) customElements.define('ssl-buy-box', SslBuyBox);
})();
